import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solution.mp4",
    poster: "/videos/solution.jpg",
    heading: "Solutions for the World's Most Critical Environments",
    subheading: "",
    buttonLink: "/support"
  }
];

function Solutions() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const solutions = [
    { name: "AI", image: "/images/solutions/ai2.jpg", slug: "ai"},
    { name: "Data Center", image: "/images/solutions/datacenter.jpg", slug: "datacenter"}, // replace with your real path
    { name: "Central Office & Headend", image: "/images/solutions/centralOffice.jpg", slug: "central-office" }, // replace with your real path
    { name: "Outside Plant", image: "/images/solutions/outsidePlant.png", slug: "outside-plant" },
    { name: "FTTX & MDU", image: "/images/solutions/ftth.jpg", slug: "fttx" },
    { name: "Rural Broadband", image: "/images/solutions/ruralBroadband.jpeg", slug: "rural-broadband" },
    { name: "Wireless", image: "/images/solutions/wireless.jpg", slug: "wireless" },
    { name: "Enterprise", image: "/images/solutions/enterprise.jpeg", slug: "/enterprise" },
    { name: "Medical Imaging", image: "/images/solutions/medicalImaging.jpeg", slug: "/medical-imaging" },
    { name: "Neuroscience", image: "/images/solutions/neuroscience.jpeg", slug: "/neuroscience" },
    { name: "Specialty Optics", image: "/images/solutions/specialtyOptics.jpeg", slug: "/specialty-optics" },
  ];

  const slugify = (s) =>
    s
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");


const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Fiber Terminals & Closures',
  'Passive Optical Components',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);
const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={slides[0].buttonLink} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <section className="solution-products-section" style={{ backgroundColor: 'white', }}>

        <div className="solutions-section-centered-text-container">
          <div className="solutions-section-iconGrid-text-container">
            <h2 className="solutions-section-iconGrid-subheading">Engineering the next generation of optical performance</h2>
            <p className="solution-section-iconGrid-description">Go!Foton brings light to life with advanced ber optics and photonics solutions designed for the most demanding environments. Whether optimizing data centers, enhancing central oce networks, enabling cutting-edge medical imaging, or connecting communities through the outside plant, we deliver results that keep you ahead. Innovation, reliability, and quality are built into everything we do.</p>
          </div>

          <section className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8 py-8 md:py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                  {solutions.map((sol) => {
                    const href = `/solutions/${sol.slug}`;
                    return (
                      <article
                        key={sol.name}
                        className="group overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md"
                      >
                        {/* Image */}
                        <div className="relative aspect-[4/3] w-full bg-gray-100">
                          {sol.image ? (
                            <img
                              src={sol.image}
                              alt={sol.name}
                              className="h-full w-full object-cover"
                              loading="lazy"
                              decoding="async"
                            />
                          ) : (
                            <div className="flex h-full w-full items-center justify-center text-gray-400">
                              <span className="text-sm">Image</span>
                            </div>
                          )}
                        </div>

                        {/* Content */}
                        <div className="p-4 md:p-5" style={{}}>
                          <center>
                          <h3 className="text-lg md:text-xl font-semibold text-gray-900 leading-snug">
                            {sol.name}
                          </h3>
                          </center>
                      

                          <div className="mt-4" style={{ display: 'flex', justifyContent: 'center', paddingBottom: 30, marginTop: -20}}>
                            <a
                              href={href}
                              className="cta-button"
                              aria-label={`View ${sol.name}`}
                            >
                              View
                            </a>
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              </section>

</div>

      </section>
        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default Solutions;
